import { ALL_PORTFOLIO_ID } from 'app-constants'
import { UserProductHistory } from 'services/query-v2/users/history/model'
import { PortfolioDataTooltipContent } from './interface'
import Big from 'big.js'
import { getProductByAddress } from 'indices-list'
import { assertMultiply, fromBNValue } from 'utils'

export const buildPortfolioTooltips = (productId: string): PortfolioDataTooltipContent => {
  const area = productId === ALL_PORTFOLIO_ID ? 'portfolio' : 'investment'
  return {
    investmentCap: {
      title: 'Invested capital',
      content: 'The amount of USD you`ve invested.',
    },
    investmentValue: {
      title: 'Investment value',
      content: `The current value of your ${area}.`,
    },
    averagePrice: {
      title: 'Average price',
      content: 'The average price paid to acquire your tokens.',
    },
    dayPrice: {
      title: 'Day price',
      content: 'The price of the day',
    },
    tokensHeld: {
      title: 'Tokens held',
      content: 'Quantity of tokens held by this account.',
    },
  }
}

// filter user product history so that only products with a history are returned
export const onlyProductsWithHistory = (item: UserProductHistory) => item.history.length !== 0

export const byInvestmentSize = (a: UserProductHistory, b: UserProductHistory) => {
  const aData = {
    balance: a.history.length !== 0 ? a.history[0].balance : Big(0),
    basePrice: a.history.length !== 0 ? a.history[0].product.basePrice : Big(0),
  }

  const bData = {
    balance: b.history.length !== 0 ? b.history[0].balance : Big(0),
    basePrice: b.history.length !== 0 ? b.history[0].product.basePrice : Big(0),
  }

  const bDecimals = getProductByAddress(b.id).decimals
  const aDecimals = getProductByAddress(a.id).decimals

  assertMultiply(fromBNValue(Big(aData.balance)), aData.basePrice)
  const aBalance = fromBNValue(Big(aData.balance).mul(aData.basePrice).toString(), aDecimals)

  assertMultiply(fromBNValue(Big(bData.balance)), bData.basePrice)
  const bBalance = fromBNValue(Big(bData.balance).mul(bData.basePrice).toString(), bDecimals)

  return bBalance.minus(aBalance).toNumber()
}
